import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logo from "../logo.png";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const indexPage = () => {
        navigate('/');
    }

    return (
        <header className="header">
            <div className="header-container">
                <div className="logo" onClick={indexPage} style={{cursor:'pointer'}}>
                    <span className="logo-icon">
                        <img src={logo} alt={'蓝英科技'} style={{width:'40px'}} />
                    </span>
                    <h1>蓝英科技</h1>
                </div>

                <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
                    <ul className="nav-list">
                        <li><a href="/#home" onClick={() => setMenuOpen(false)}>首页</a></li>
                        <li><a href="/#features" onClick={() => setMenuOpen(false)}>主营业务</a></li>
                        <li><a href="/#case-studies" onClick={() => setMenuOpen(false)}>成功案例</a></li>
                        <li><a href="/#about" onClick={() => setMenuOpen(false)}>关于蓝英</a></li>
                        <li><a href="/#contact" onClick={() => setMenuOpen(false)}>联系我们</a></li>
                    </ul>
                </nav>

                <button className="menu-toggle" onClick={toggleMenu}>
                    {menuOpen ? '✕' : '☰'}
                </button>
            </div>
        </header>
    );
}

export default Header;
